import { apiClient } from './api'
import { resolveEventId } from './eventService'

/** Live session engagement (polls + Q&A). Requires an attendee session. */

export interface PollOption {
  id: string
  label: string
  ordinal: number
  votes: number
}
export interface Poll {
  id: string
  sessionIds: string[]
  question: string
  status: 'draft' | 'open' | 'closed'
  ordinal: number
  totalVotes: number
  myOptionId?: string | null
  options: PollOption[]
}
export interface Question {
  id: string
  sessionId?: string | null
  body: string
  authorName?: string | null
  answered: boolean
  answer?: string | null
  answeredBy?: string | null
  answeredAt?: string | null
  upvotes: number
  upvoted: boolean
  mine: boolean
  createdAt?: string | null
}

export const engageService = {
  listPolls: async (sessionId?: string): Promise<Poll[]> => {
    const id = await resolveEventId()
    return apiClient
      .get<Poll[]>(`/events/${id}/polls`, {
        params: sessionId ? { sessionId } : undefined,
      })
      .then((r) => r.data)
  },
  vote: async (pollId: string, optionId: string): Promise<Poll> => {
    const id = await resolveEventId()
    return apiClient
      .post<Poll>(`/events/${id}/polls/${pollId}/vote`, { optionId })
      .then((r) => r.data)
  },
  listQuestions: async (sessionId?: string): Promise<Question[]> => {
    const id = await resolveEventId()
    return apiClient
      .get<Question[]>(`/events/${id}/questions`, {
        params: sessionId ? { sessionId } : undefined,
      })
      .then((r) => r.data)
  },
  submitQuestion: async (
    body: string,
    sessionId?: string,
    anonymous = false,
  ): Promise<void> => {
    const id = await resolveEventId()
    await apiClient.post(`/events/${id}/questions`, { body, sessionId, anonymous })
  },
  toggleUpvote: async (questionId: string): Promise<{ upvoted: boolean }> => {
    const id = await resolveEventId()
    return apiClient
      .post<{ upvoted: boolean }>(`/events/${id}/questions/${questionId}/upvote`)
      .then((r) => r.data)
  },
}
